module.exports = __webpack_public_path__ + "img/10.bce24176.png";